// Parte 2 · bloques del resumen por hoja: «Creditos» (con Integrantes) y «Corregir creditos».
const Tile = ({ label, value, testid, tono = "text-slate-700" }) => (
  <div className="rounded-md border border-slate-200 bg-white px-3 py-2" data-testid={testid}>
    <p className="text-[11px] uppercase tracking-wide text-slate-400">{label}</p>
    <p className={`mt-0.5 font-mono text-lg tabular-nums ${tono}`}>{value ?? 0}</p>
  </div>
);

const Bloque = ({ titulo, r, prefijo, nota }) => (
  <div className="rounded-md border border-slate-200 bg-slate-50/60 p-3" data-testid={`${prefijo}-bloque`}>
    <p className="text-sm font-semibold text-slate-800">{titulo}</p>
    {nota && <p className="mt-0.5 text-xs text-slate-500">{nota}</p>}
    <div className="mt-2 grid grid-cols-2 gap-2 sm:grid-cols-4">
      <Tile label="Total" value={r.total} testid={`${prefijo}-total`} />
      <Tile label="Válidos" value={r.validos} testid={`${prefijo}-validos`} tono="font-semibold text-slate-900" />
      <Tile label="Con error" value={r.error} testid={`${prefijo}-errores`} tono="text-red-700" />
      <Tile label="Con advertencia" value={r.advertencia} testid={`${prefijo}-advertencias`} tono="text-amber-700" />
    </div>
  </div>
);

export function ResumenCreditos({ lote }) {
  const cr = lote.creditos || {};
  const co = lote.correcciones || {};
  if (!cr.total && !co.total) return null;
  return (
    <div className="grid gap-3 lg:grid-cols-2" data-testid="migracion-resumen-creditos">
      {cr.total > 0 && (
        <Bloque titulo="Créditos (con integrantes)" r={cr} prefijo="migracion-creditos"
          nota="No consumen consultas del plan. Nacen autorizados por migración, sin pasar por el Comité." />
      )}
      {co.total > 0 && (
        <Bloque titulo="Corregir créditos" r={co} prefijo="migracion-correcciones"
          nota="Conservan número, cliente, expediente y pagos reales: la tabla se recalcula desde la fecha original y los pagos reales se reaplican." />
      )}
    </div>
  );
}
